<template>
  <v-app class="del-bg">
    <div class="row mt-0 mb-4">
      <div class="col-12 col-md-6">
        <div class="block-search" @click="handleClick">
          <div class="search-container">
            <div class="input-filters">
              <span class="info-icon-filters" v-show="valueSkill.length > 0">навыки</span>
              <span class="info-icon-filters" v-show="valueStatus.length > 0">статусы</span>
            </div>
            <input
              type="text"
              :style="getStyleFromFilter()"
              class="field custom-search"
              placeholder="Поиск"
              v-model="search"
            >
            <a href="#" class="password-control icon-search" @click="goSearch()">
              <v-icon>mdi-magnify</v-icon>
            </a>
          </div>
          <div class="popup-filter" v-show="showFilter" @click.stop>
            <v-btn class="close-button filter-close"
              title="Отменить"
              variant="text"
              text
              @click="closeFilter"
            >
              <v-icon>ti-close</v-icon>
            </v-btn>
          <!-- <div class="popup-filter"> -->
            <div class="filter-block filter-status">
              <p>Статусы</p>
              <div class="filter-select">
                <multiselect 
                  class="custom-ul"
                  v-model="valueStatus" 
                  placeholder="Выберите статусы" 
                  label="title" 
                  track-by="name"
                  :multiple="true"
                  :options="optionsStatus" 
                  :option-height="90" 
                  :close-on-select="false"
                  :show-labels="false"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <div style="display:flex; align-items: center;">
                      <span style="display:none">{{props.option.name}}</span>
                      <span class="option__desc" style="height: 40px; padding-top: 2px;">
                        <p style="font-size: 12px;">Навыки</p>
                        <h4 style="font-size: 14px;">{{ props.option.title }}</h4>
                      </span>
                    </div>
                  </template>
                  <template slot="option" style="display:flex" slot-scope="props">
                    <div style="display:flex; align-items: center;">
                      <span style="display:none">{{props.option.name}}</span>
                      <div class="option__desc">
                        <span style="font-size: 14px; font-family: 'Montserrat', sans-serif;" class="option__title">{{ props.option.title }}</span>
                      </div>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
            <div class="filter-block filter-skills">
              <p>Навыки</p>
              <div class="filter-select">
                <multiselect 
                  class="custom-ul"
                  v-model="valueSkill" 
                  placeholder="Выберите навыки" 
                  label="title" 
                  track-by="id"
                  :multiple="true"
                  :options="optionsSkill" 
                  :option-height="90" 
                  :close-on-select="false"
                  :show-labels="false"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <div style="display:flex; align-items: center;">
                      <span style="display:none">{{props.option.id}}</span>
                      <span class="option__desc" style="height: 40px; padding-top: 2px;">
                        <p style="font-size: 12px;">Навыки</p>
                        <h4 style="font-size: 14px;">{{ props.option.title }}</h4>
                      </span>
                    </div>
                  </template>
                  <template slot="option" style="display:flex" slot-scope="props">
                    <div style="display:flex; align-items: center;">
                      <span style="display:none">{{props.option.id}}</span>
                      <div class="option__desc">
                        <span style="font-size: 14px; font-family: 'Montserrat', sans-serif;" class="option__title">{{ props.option.title }}</span>
                      </div>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
            <div class="flex">
              <v-btn
                class="customGlobalBtn mt-8 mb-3 mr-4 btn-search primary-btn"
                variant="text"
                text
                @click="saveFilter()"
              >
                <v-icon>mdi-magnify</v-icon> Найти
              </v-btn>
              <v-btn
                class="customGlobalBtn emptyBtn mt-8 mb-3"
                variant="text"
                text
                @click="delFilter()"
              >
                Сбросить
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 block-tab-btn">

        <v-dialog v-model="dialogFields" max-width="300px">
          <v-card class="cardCustom" style="padding: 10px 0 !important;">
            <v-btn
              class="close-button"
              title="Отменить"
              variant="text"
              text
              @click="closeFields"
            >
              <v-icon>ti-close</v-icon>
            </v-btn>
            <div>
              <v-card-title style="text-align: center; display: block; font-size: 18px; padding-bottom: 0;">Настройка полей</v-card-title>
            </div>
            <v-card-text style="padding-top: 15px; padding-bottom: 0;">
              <v-container>
                <div v-for="field in headers">
                  
                  <div v-if="field.show != 'none'" class="block-check-field">
                    <v-checkbox
                      class="custom-check"
                      v-model="selectedFields"
                      :value="field.value"
                      hide-details
                      :ripple="false"
                      @click="getSelectedFields(field.value)"
                    >
                    </v-checkbox>
                    <span>{{ field.text }}</span>
                  </div>
                  
                </div>
              </v-container>
            </v-card-text>

            <div class="text-center" >
              <v-col cols="12" md="12" class="input-text" style="padding: 0 36px;">
                <v-btn type="submit" class="btnSave primary-btn" @click="saveFields()">
                  Сохранить
                </v-btn>
              </v-col>
            </div>
          </v-card>
        </v-dialog>

        <v-dialog v-if="isAdmin" v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="customGlobalBtn mb-0 emptyBtn"
              variant="text"
              text
              v-bind="attrs"
              v-on="on"
            >
              Создать пользователя
            </v-btn>
          </template>
          <v-card class="cardCustom" style="padding: 10px 0 !important;">
            <v-btn
              class="close-button"
              title="Отменить"
              variant="text"
              text
              @click="close"
            >
              <v-icon>ti-close</v-icon>
            </v-btn>
            <div>
              <v-card-title style="text-align: center; display: block; font-size: 18px; padding-bottom: 0;">{{ formTitle }}</v-card-title>
            </div>
            <v-card-text>
              <v-container>
                <v-form ref="form">
                <v-row>
                  <v-col cols="12" md="6" class="input-text">
                    <label>Имя</label>
                    <v-text-field
                      type="text" 
                      v-model="editedItem.name"
                      :rules="textRulesRequire"
                      maxlength="50"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="input-text">
                    <label>Фамилия</label>
                    <v-text-field
                      v-model="editedItem.lastName"
                      :rules="textRules"
                      maxlength="50"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="input-text">
                    <label>Отчество</label>
                    <v-text-field
                      v-model="editedItem.secondName"
                      :rules="textRules"
                      maxlength="50"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="input-text">
                    <label>Логин</label>
                    <v-text-field
                      v-model="editedItem.login"
                      :style="{'color: #b4b4b4': editedItem.externalId != ''}"
                      maxlength="50"
                      :disabled="!!(editedItem && editedItem.externalId)"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="input-text">
                    <label>E-mail</label>
                    <v-text-field
                      v-model="editedItem.email"
                      :rules="emailRules"
                      :disabled="!!(editedItem && editedItem.externalId)"
                      maxlength="50"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="input-text">
                    <label>Телефон</label>

                    <v-text-field
                      v-model="editedItem.phone"
                      maxlength="20"
                      :rules="phoneRules"
                      @keypress="onlyPhoneChars"
                      @input="onPhoneInput($event, 'phone')"
                    ></v-text-field>

                  </v-col>
                  <v-col cols="12" md="6" class="input-text">
                    <label>Мобильный телефон</label>

                    <v-text-field 
                      v-model="editedItem.mobile"
                      maxlength="20"
                      :rules="phoneRules"
                      @keypress="onlyPhoneChars"
                      @input="onPhoneInput($event, 'mobile')"
                    ></v-text-field>

                  </v-col>
                  <v-col cols="12" md="6" class="input-text">
                    <label>Telegram</label>
                    <v-text-field
                      v-model="editedItem.telegram"
                      :rules="telegaRules"
                      maxlength="50"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="editedItem.externalId == ''" cols="12" md="12" class="custom-selected1">
                    <label>Руководитель</label>
                    <multiselect 
                      class="custom-ul"
                      v-model="value" 
                      placeholder="Введите для поиска" 
                      label="title" 
                      track-by="id"
                      :multiple="true"
                      :options="options" 
                      :option-height="90" 
                      :custom-label="customLabel" 
                      :close-on-select="false"
                      :show-labels="false"
                    >
                      <span slot="noResult">Нет результатов</span>
                      <template slot="singleLabel" slot-scope="props">
                        <img class="option__image select-img" :src="props.option.img">
                        <span class="option__desc">
                          <span class="option__title">{{ props.option.title }}</span>
                        </span>
                      </template>
                      <template slot="option" style="display:flex" slot-scope="props">
                        
                        <div class="option__desc">
                          <img v-if="props.option.img != 'noFoto'" class="option__image select-img" style="margin-right: 10px; border-radius: 30px" :src="props.option.img">
                          <img v-else class="option__image select-img" style="margin-right: 10px; border-radius: 30px" src="@/assets/img/no-foto.png" alt="" />
                          <span class="option__title">{{ props.option.title }}</span>
                        </div>
                      </template>
                    </multiselect>
                    <!-- <pre>{{value}}</pre> -->
                  </v-col>
                </v-row>
              </v-form>
              </v-container>
            </v-card-text>

            <div class="text-center">
              <v-btn type="submit" class="btnSave primary-btn" @click="save">
                Сохранить
              </v-btn>
            </div>
          </v-card>
        </v-dialog>

        <!-- <v-btn
          v-show="isAdmin"
          class="customGlobalBtn mb-0 emptyBtn ml-2 sync-btn"
          variant="text"
          title="Загрузить пользователей"
          text
          @click="getAllUsers()"
        >
          <v-icon>mdi-sync</v-icon>
        </v-btn> -->

      </div>
    </div>
    <div>
      <transition name="fade">
        <section style="position: absolute; width: 100%;">
          <v-container v-if="preloader">
            <div class="text-center">
              <v-progress-circular indeterminate></v-progress-circular>
            </div>
          </v-container>
        </section>
      </transition>
      <transition name="fade">
        <v-data-table
          v-if="!preloader"
          :headers="headers"
          :items="items"
          :search="search"
          :custom-filter="customSearch"
          :options.sync="tableOptions"
          class="elevation-1"
        >
          <template v-slot:header.actions="{ header }">
            <div class="cog-table" @click="showDialogFields()">
              <v-icon>mdi-cog</v-icon>
            </div>
          </template>
          <template v-slot:header.id="{ header }">
            <span class="font-class">{{ header.text }}</span>
          </template>
          <template v-slot:header.name="{ header }">
            <span class="font-class">{{ header.text }}</span>
          </template>
          <template v-slot:header.avatar="{ header }">
            <span class="font-class">{{ header.text }}</span>
          </template>
          <template v-slot:header.skills="{ header }">
            <span class="font-class">{{ header.text }}</span>
          </template>
          <template v-slot:header.email="{ header }">
            <span class="font-class">{{ header.text }}</span>
          </template>
          <template v-slot:header.telegram="{ header }">
            <span class="font-class">{{ header.text }}</span>
          </template>
          <template v-slot:header.phone="{ header }">
            <span class="font-class">{{ header.text }}</span>
          </template>
          <template v-slot:header.mobile="{ header }">
            <span class="font-class">{{ header.text }}</span>
          </template>
          <template v-slot:header.login="{ header }">
            <span class="font-class">{{ header.text }}</span>
          </template>

          
          
          <template v-slot:item.name="{ item }">
            <span class="link-p" @click="goToProfile(item)">{{ item.name }} {{ item.lastName }} {{ item.secondName }}</span>
          </template>
          <template v-slot:item.phone="{ item }"><div style="min-width: 156px;">{{ item.phone }}</div></template>
          <template v-slot:item.email="{ item }">
            <a v-if="item.email" :href="'mailto:' + item.email" target="_blank">{{item.email}}</a>
          </template>
          <template v-slot:item.mobile="{ item }"><div style="min-width: 156px;">{{ item.mobile }}</div></template>

          <template v-slot:item.avatar="{ item }">
            <div class="container-img">
              <div 
                v-if="item.avatar"
                class="custom-bg-img"
                :style="getStyleAvatar(item.avatar)"
              ></div>
              <img v-else src="@/assets/img/no-foto.png">
            </div>
          </template>

          <template v-slot:item.telegram="{ item }">
            <a v-if="item.telegram " :href="'https://t.me/' + item.telegram" target="_blank">@{{item.telegram}}</a>
          </template>

          <template v-slot:item.status="{ item }">
            <div style="min-width: 100px;">
              <span :class="getStatusColor(item.status)" class="tab-status">
                {{ getUserStatus(item.status) }}
              </span>
            </div>
          </template>

          <template v-slot:item.actions="{ item }" >
            <v-menu topright>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2 size"
                  title="Действия"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-menu
                </v-icon>
              </template>
        
              <v-list class="settings-list">
                <v-list-item class="item-setting">
                  <v-list-item-title>
                    <span @click="goToProfile(item)">Открыть</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="isAdmin" class="item-setting">
                  <v-list-item-title>
                    <span @click="editItem(item)">Редактировать</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="item-setting">
                  <v-list-item-title>
                    <span @click="goToCompetention(item)">Компетенции</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="item-setting" v-if="localUser && localUser != item.id">
                  <v-list-item-title>
                    <span @click="addInterview(item)">Назначить интервью</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
              
            </v-menu>
          </template>

          <template v-slot:item.skills="{ item }">
            <template 
              v-if="(item.hardSkills && item.hardSkills.areas && item.hardSkills.areas.length) 
              || (item.softSkills && item.softSkills.areas && item.softSkills.areas.length)"
            >
              <avatars-group
                v-if="item.hardSkills.areas.length"
                :items="item.hardSkills.areas"
                class="avatarGroup"
                type="hard"
                :limit="5"
              ></avatars-group>
              <avatars-group
                v-if="item.softSkills.areas.length"
                :items="item.softSkills.areas"
                class="avatarGroup"
                type="soft"
                :limit="5"
              ></avatars-group>
            </template>
            <div v-else class="table-small-text">Нет навыков</div>
          </template>

          <template v-slot:item.login="{ item }">
            <span v-if="item && item.login && item.login.includes('bitrix_temporary')">Не авторизован</span>
            <span v-else>{{item.login}}</span>
          </template>

          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize"> Обновить </v-btn>
          </template>
        </v-data-table>
      </transition>
    </div>
  </v-app>
</template>

<script>
import AvatarsGroup from "@/components/Cards/AvatarsGroup";
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";

import GlobalRequest from "@/plugins/globalRequest"
import globalMethods from "@/plugins/globalMethods"

export default {
  inject: ['usersStore', 'setUsersStore', 'openInterview'],

  components: {
    AvatarsGroup,
    Multiselect,
    GlobalRequest,
    globalMethods,
  },
  props: {},
  data() {
    return {
      showFilter: false,
      valueSkill: [],
      optionsSkill: [],
      valueStatus: [],
      optionsStatus: [],
      selectedFields: [],
      localUser: 0,
      titleInterview: "",
      successText: "",
      errorText: "",
      dateInterview: this.getDate(),
      checkUser: '',
      isAdmin: true,
      isHead: false,
      preloader: true,
      showMenu: false,
      emailRules: [
        v => !!v || 'Поле обязательно для заполнения',
        v => (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i.test(v)) || 'E-mail некорректен',
      ],
      loginRules: [
        v => !!v || 'Поле обязательно для заполнения',
        v => (/^[-_A-Za-z0-9]+$/i.test(v)) || 'Логин содержит недопустимые символы',
      ],
      telegaRules: [
         v => ((/^[-_A-Za-z0-9]*$/i.test(v))) || 'Поле содержит недопустимые символы',
      ],
      textRulesRequire: [
        v => (/^[\s\-_A-Яa-я0-9]+$/i.test(v)) || 'Поле содержит недопустимые символы'
      ],
      textRules: [
        v => (/^[\s\-_A-Яa-я0-9]*$/i.test(v)) || 'Поле содержит недопустимые символы'
      ],
      textRulesInterview: [
        v => (/^[\s\-_!)(*&?#№%:^A-Яa-я0-9]*$/i.test(v)) || 'Поле содержит недопустимые символы'
      ],
      phoneRules: [
        v => (!v || /^[0-9+\-\s()]+$/.test(v)) || 'Поле содержит недопустимые символы'
      ],
      emptyRules: [
        v => !!v || 'Поле обязательно для заполнения'
      ],
      selected: null,
      search: "",
      dialog: false,
      dialogDelete: false,
      dialogFields: false,
      users: [],
      departments: [
        { id: 1, name: "Коммерческая служба" },
        { id: 2, name: "Производство" },
        { id: 3, name: "Разработчики" },
        { id: 4, name: "Аналитика" },
        { id: 5, name: "Внедрение" },
      ],
      positions: [
        { id: 1, name: "Кандидат" },
        { id: 1, name: "Разработчик" },
        { id: 2, name: "Аналитик" },
        { id: 3, name: "Специалист по внедрению" },
        { id: 4, name: "HR" },
        { id: 5, name: "Бизнес аналитик" },
        { id: 6, name: "Менеджер проектов" },
      ],
      roles: [],
      headers: [
        { text: '', value: 'actions', sortable: false, show:'none' },
        { text: 'id', align: 'start', value: 'id', width: 67 },
        { text: 'Фото', value: 'avatar', sortable: false },
        { text: 'ФИО', value: 'name' },
        // { text: 'lastName', value: 'lastName', align:' d-none', show:'none' },
        // { text: 'secondName', value: 'secondName', align: ' d-none', show:'none' },
        { text: 'Навыки', value: 'skills', sortable: false},
        { text: 'E-mail', value: 'email' },
        { text: 'Telegram', value: 'telegram', width: 119 },
        { text: 'Телефон', value: 'phone' },
        { text: 'Мобильный', value: 'mobile' },
        { text: 'Логин', value: 'login' },
        { text: 'Статус', value: 'status' }
      ],
      items: [],
      editedIndex: -1,
      editedItem: {
        name: "",
        age: 0,
        department: "",
        role: "",
        rights: [],
      },
      defaultItem: {
        name: "",
        age: 0,
        department: "",
        role: "",
        rights: [],
      },
      tableOptions: {
        sortBy: ['id'],
        sortDesc: [true],
        itemsPerPage: 15
      },
      type: ["", "info", "success", "warning", "danger"],
      
      participantsOptions: [],
      rootData: {},
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Создание пользователя"
        : "Редактирование пользователя";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogFields(val) {
      val || this.closeFields();
    },
    search() {
      this.showFilter = false;
    },

    tableOptions: {
      deep: true,
      handler(val) {
        localStorage.setItem(
          'usersTableOptions_' + this.localUser,
          JSON.stringify(val)
        );
      }
    },

  },

  async mounted() {
    // Собрать статусы пользователей
    const statuses = globalMethods.userStatus();
    this.optionsStatus = Object.entries(statuses).map(([name, title]) => ({
      name,
      title
    }));

    document.addEventListener('click', this.hidePopup);

    const storedUser = localStorage.getItem('current_user');
    if (storedUser) {
      this.localUser = storedUser;
    }

    let filterSkills = []

    let result = await GlobalRequest.request("/root/" + this.localUser, "GET")

    if (result) {

      this.rootData = result;

      if (result.hardSkills && Array.isArray(result.hardSkills.areas)) {
        filterSkills = result.hardSkills.areas.slice();
      }

      if (result.softSkills && Array.isArray(result.softSkills.areas)) {
        filterSkills = filterSkills.concat(result.softSkills.areas);
      }
    }

    this.optionsSkill = filterSkills;


    let savedOptions = localStorage.getItem('usersTableOptions_' + this.localUser);

    if (savedOptions) {
      try {
        this.tableOptions = JSON.parse(savedOptions);
      } catch (e) {
        console.warn('Ошибка восстановления настроек таблицы', e);
      }
    }
    
    this.roles = globalMethods.getRoles()

    // Есть ли у пользователя админские права
    this.isAdmin = globalMethods.isAdmin(this.roles);

    // проверим сохраненные поля таблицы для текущего пользователя
    let currUserFields = localStorage.getItem('tableFields_' + this.localUser);
    if (currUserFields){
      this.headers = JSON.parse(currUserFields)
      for(let i in this.headers) {
        if(this.headers[i].align == "")
          this.selectedFields.push(this.headers[i].value)
      }
    }
    else {
      this.visibleFields()
    }

    this.valueSkill = [];
    this.valueStatus = [];

    let filterSkill = localStorage.getItem('tableFilterSkill_' + this.localUser);
    if (filterSkill) {
      this.valueSkill = JSON.parse(filterSkill)
    }

    let filterStatus = localStorage.getItem('tableFilterStatus_' + this.localUser);
    if (filterStatus) {
      this.valueStatus = JSON.parse(filterStatus)
    }

    this.selectedFields.push("actions")

    if (this.valueSkill.length > 0 || this.valueStatus.length > 0) await this.initialize(true);
    else await this.initialize();
  },

  beforeDestroy() {
    document.removeEventListener('click', this.hidePopup);
  },

  methods: {

    getStyleFromFilter() {
      if(this.valueSkill.length > 0 || this.valueStatus.length > 0) {
        return "padding: 15px 15px 15px 63px !important;"
      }
    },

    hidePopup(event) {
      const blockSearch = this.$el && this.$el.querySelector('.custom-search');
      if (!blockSearch || !blockSearch.contains(event.target)) {
        this.showFilter = false;
      }
    },

    async delFilter() {
      this.valueSkill = []
      this.valueStatus = []

      this.clearFilterFromStorage("tableFilterSkill_")
      this.clearFilterFromStorage("tableFilterStatus_")

      this.showFilter = false
      await this.initialize()
    },

    async saveFilter() {
      this.showFilter = false

      if (!this.valueSkill.length) {
        this.clearFilterFromStorage("tableFilterSkill_")
      }

      if (!this.valueStatus.length) {
        this.clearFilterFromStorage("tableFilterStatus_")
      }

      await this.initialize(true)
    },

    handleClick(event) {
      this.showFilter = true;
    },

    closeFilter() {
      this.showFilter = false;
    },

    async goSearch() {
      if (this.valueSkill.length > 0 || this.valueStatus.length > 0 || this.search.length > 0) {
        await this.initialize(true)
      }
    },

    async getAllUsers() {
      this.preloader = true
      await GlobalRequest.request("/user/load", "GET");
      await this.initialize()
    },

    visibleFields() {
      for(let i in this.headers) {
        let field = this.headers[i]
        if(field.value != "id" && field.value != "phone" && field.value != "mobile" && field.value != "login" && field.value != "status") {
          this.selectedFields.push(this.headers[i].value)
        }
        else {
          field.align = " d-none"
        }
      }
    },

    getStyleAvatar(path) {
      return 'background-image: url("' + path + '"); height: 100%; width: 100%;'
    },

    updateHeaderVisibility(fieldName, visible) {
      for (let i = 0; i < this.headers.length; i++) {
        if (this.headers[i].value === fieldName) {
          this.headers[i].align = visible ? "" : " d-none";
        }
      }
    },
    
    async initialize(filter) {
      this.preloader = true;

      try {
        const users = await this.loadUsers();
        this.items = this.prepareItems(users);

        if (filter) {
          this.applySkillFilter();
          this.applyStatusFilter();
        }
      } finally {
        this.preloader = false;
      }
    },

    async loadUsers() {
      var result = await GlobalRequest.request("/user/list/v2", "GET");
      var users = (result && result.data) ? result.data : [];

      var areaRightsMap = this.buildAreaRightsMap(this.rootData);

      var usersWithRights = users.map(function (user) {
        if (!user || !user.skills) return user;

        var skills = user.skills;

        // обработка hardSkills.areas
        if (skills.hardSkills && Array.isArray(skills.hardSkills.areas)) {
          skills = Object.assign({}, skills, {
            hardSkills: Object.assign({}, skills.hardSkills, {
              areas: skills.hardSkills.areas.map(function (a) {
                if (!a || !a.element || !a.element.id) return a;

                return Object.assign({}, a, {
                  element: Object.assign({}, a.element, {
                    viewerRights: areaRightsMap[a.element.id] || null
                  })
                });
              })
            })
          });
        }

        // обработка softSkills.areas
        if (skills.softSkills && Array.isArray(skills.softSkills.areas)) {
          skills = Object.assign({}, skills, {
            softSkills: Object.assign({}, skills.softSkills, {
              areas: skills.softSkills.areas.map(function (a) {
                if (!a || !a.element || !a.element.id) return a;

                return Object.assign({}, a, {
                  element: Object.assign({}, a.element, {
                    viewerRights: areaRightsMap[a.element.id] || null
                  })
                });
              })
            })
          });
        }

        return Object.assign({}, user, { skills: skills });
      });

      this.users = usersWithRights;
      console.log(this.users)

      return usersWithRights;
    },

    buildAreaRightsMap(rootData) {
      var map = {};

      function collect(areas) {
        if (!Array.isArray(areas)) return;
        areas.forEach(function (area) {
          if (area && area.id && area.viewerRights) {
            map[area.id] = area.viewerRights;
          }
        });
      }

      if (rootData && rootData.hardSkills) collect(rootData.hardSkills.areas);
      if (rootData && rootData.softSkills) collect(rootData.softSkills.areas);

      return map;
    },

    prepareItems(users) {
      var items = [];

      for (var i = 0; i < users.length; i++) {
        var u = users[i];

        var user = Object.assign({}, u.user);
        // user.id = u.user.id;

        var skills = u && u.skills ? u.skills : {};

        user.hardSkills = skills.hardSkills && skills.hardSkills.areas
          ? { areas: skills.hardSkills.areas.slice() }
          : { areas: [] };

        user.softSkills = skills.softSkills && skills.softSkills.areas
          ? { areas: skills.softSkills.areas.slice() }
          : { areas: [] };

        items.push(user);
      }

      items.sort(function (a, b) {
        return a.id - b.id;
      });

      return items;
    },

    applySkillFilter() {
      if (!this.valueSkill || this.valueSkill.length === 0) {
        this.clearFilterFromStorage("tableFilterSkill_")
        return
      }

      if (!this.selectedFields.includes("skills")) {
        this.selectedFields.push("skills");
      }

      this.updateHeaderVisibility("skills", true);
      this.saveTableFields();

      var skillTitles = [];

      for (var i = 0; i < this.valueSkill.length; i++) {
        skillTitles.push(this.valueSkill[i].title);
      }

      this.items = this.items.filter(function (item) {
        var hard = item.hardSkills && item.hardSkills.areas || [];
        var soft = item.softSkills && item.softSkills.areas || [];

        for (var i = 0; i < skillTitles.length; i++) {
          var title = skillTitles[i];

          var hasHard = hard.some(function (a) {
            return a.element && a.element.title === title;
          });

          var hasSoft = soft.some(function (a) {
            return a.element && a.element.title === title;
          });

          if (hasHard || hasSoft) {
            return true;
          }
        }

        return false;
      });

      this.saveToStorage("tableFilterSkill_", this.valueSkill);
    },

    applyStatusFilter() {
      if (!this.valueStatus || this.valueStatus.length === 0) {
        this.clearFilterFromStorage("tableFilterStatus_")
        return
      }

      if (!this.selectedFields.includes("status")) {
        this.selectedFields.push("status");
      }

      this.updateHeaderVisibility("status", true);
      this.saveTableFields();

      var statusMap = {};

      for (var i = 0; i < this.valueStatus.length; i++) {
        statusMap[this.valueStatus[i].name] = true;
      }

      var uniq = {};

      this.items = this.items.filter(function (item) {
        if (statusMap[item.status] && !uniq[item.id]) {
          uniq[item.id] = true;
          return true;
        }
        return false;
      });

      this.saveToStorage("tableFilterStatus_", this.valueStatus);
    },

    saveTableFields() {
      localStorage.setItem(
        "tableFields_" + this.localUser,
        JSON.stringify(this.headers)
      );
    },

    saveToStorage(key, value) {
      localStorage.setItem(
        key + this.localUser,
        JSON.stringify(value)
      );
    },

    clearFilterFromStorage(key) {
      localStorage.removeItem(key + this.localUser)
    },

    getDate() {
      // 2023-10-26T18:32
      let date= new Date();
      let day = "0" + date.getDate();
      let month = "0" + (date.getMonth()+1);
      let year = date.getFullYear();
      let hours = "0" + date.getHours();
      let minutes = "0" + date.getMinutes();
      let seconds = "0" + date.getSeconds();

      return year + "-" + month.substr(-2) + "-" + day.substr(-2) + "T" + hours.substr(-2) + ':' + minutes.substr(-2);
    },

    goToProfile(item) {
      this.$router.push({
        name: 'profile',
        query: {
          // user: item,
          userID: item.id,
          userStatus: item.status,
          back: this.$route.name
        }
      });
    },

    goToCompetention(item) {
      this.$router.push({
        name: 'areasLayout',
        query: {
          userID: item.id,
          back: this.$route.name
        },
      });
    },

    customLabel ({ title }) {
      return `${title}`
    },

    getPhone(phone) {
      if (!phone) return "";
      let p = phone.replace(/[()\-\s]/g, "");
      if (p.startsWith("+7")) return p.substr(2);
      if (p.startsWith("8")) return p.substr(1);
      return p;
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      
      this.dialog = true;
    },

    addInterview(item) {
      this.openInterview(item.id);
    },

    deleteItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.items.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeFields() {
      this.dialogFields = false;
    },

    async save() {
      let valid = await this.$refs.form.validate()

      if (valid) {
        let body = {
            login: this.editedItem.login,
            email: this.editedItem.email,
            name: this.editedItem.name,
            secondName: this.editedItem.secondName,
            lastName: this.editedItem.lastName,
            phone: this.editedItem.phone,
            mobile: this.editedItem.mobile,
            telegram: this.editedItem.telegram
          };
          console.log(body)
        if (this.editedIndex > -1) {
          let result = await GlobalRequest.request("/user/" + this.editedItem.id + "/update", "POST", body);
          Object.assign(this.items[this.editedIndex], this.editedItem);
        } 
        else {
          let result = await GlobalRequest.request("/user/add", "POST", body);
          this.editedItem.id = this.items.length + 1 
          this.editedItem.active = false 
          this.editedItem.status = 'blank'
          this.editedItem.hardSkills = [],
          this.editedItem.softSkills = []
          this.items.unshift(this.editedItem);
        }
        this.close();
        this.initialize();

        // Обновить список пользователей usersStore
        await this.refreshUsersStore();
      }
    },

    showDialogFields() {
      this.dialogFields = true
    },

    getSelectedFields(field) {
      console.log(this.selectedFields)
    },

    async saveFields() {
      console.log(this.headers)
      console.log(this.selectedFields)

      this.dialogFields = false
      for(let i in this.headers) {
        let field = this.headers[i] 
        if(field.value == 'actions')
          field.align = ""
        else if (
          Array.isArray(this.selectedFields) &&
          this.selectedFields.includes(field.value)
        ) {
          field.align = ""
        }
        else {
          field.align = " d-none"
          if(field.value == "status") this.valueStatus = []
          if(field.value == "skills") this.valueSkill = []
        }
      }

      // сохранили массив с заголовками для текущего пользователя
      localStorage.setItem('tableFields_' + this.localUser, JSON.stringify(this.headers));
      await this.initialize();
    },

    getStatusColor(status) {
      const map = globalMethods.userStatusClass();
      return map[status] || "";
    },

    getUserStatus(status) {
      const map = globalMethods.userStatus();
      return map[status] || "";
    },

    onlyPhoneChars(e) {
      const char = String.fromCharCode(e.which);
      if (!/[0-9+\-\s()]/.test(char)) {
        e.preventDefault();
      }
    },

    onPhoneInput(value, field) {
      if (typeof value !== 'string') return;

      const cleaned = value.replace(/[^0-9+\-\s()]/g, '');

      this.$set(this.editedItem, field, cleaned);
    },

    notifyVue(verticalAlign, horizontalAlign, color, text) {
      this.$notify({
        component: NotificationTemplate,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: this.type[color],
        message: text,
      });
    },

    customSearch(value, search, item) {
      if (!search) return true;

      const s = search.toLowerCase();
      const data = item && item.raw ? item.raw : item;
      if (!data) return false;

      const haystack = [
        data.name,
        data.lastName,
        data.secondName,
        data.login,
        data.email,
        data.phone,
        data.mobile
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      return haystack.includes(s);
    },

    // Обновить список пользователей
    async refreshUsersStore() {

      let usersArr = [];

      if (this.isAdmin) {
        const res = await GlobalRequest.request("/user/list", "GET");
        if(res && res.data) {
          usersArr = res.data;
        }
      } else {
        const resUser = await GlobalRequest.request("/user/" + this.localUser, "GET");
        if (resUser && resUser.data) {
          const subordinates = Array.isArray(resUser.data.subordinates)
            ? resUser.data.subordinates
            : [];

          const padawans = Array.isArray(resUser.data.padawans)
            ? resUser.data.padawans
            : [];

          usersArr = [...subordinates, ...padawans];

          // В список добавить себя
          if(this.usersArr && this.usersArr.length > 0 && resUser && resUser.data) {
            this.usersArr.push(resUser.data)
          }

        }
      }

      this.setUsersStore(usersArr);

    },

  },
};
</script>

<style scoped>
  .del-bg input {
    font-size: 14px !important;
  }
  .link-p {
    transition: 0.3s;
    cursor: pointer;
  }
  .link-p:hover {
    text-decoration: underline;
  }

  .custom-search label {
    top: 8px;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
  }
  .v-data-table__wrapper {
    background: red !important;
  }

  .icon-search {
    height: 100%;
    top: 0px;
    right: 0;
    padding: 6px 0px;
    width: 29px;
  }
  .icon-search i {
    transition: 0.3s;
    color: #6d7986;
  }
  .icon-search i:hover {
    color: #000;
  }
  .block-search input::placeholder {
    color: #6d7986;
    font-weight: 400;
    font-family: "Montserrat", sans-serif !important;
  }
  .block-search .flex {
    justify-content: center;
  }
  .custom-search {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    min-height: 10px;
    height: 36px;
    margin: 0;
    padding: 15px;
    background: #fff;
    color: #6d7986 !important;
    border: 1px solid #e0e0e0;
    font-weight: 500;
    font-family: "Montserrat", sans-serif !important;
    border-radius: 4px;
  }
  .cog-table {
    cursor: pointer;
  }
  .cog-table i {
    font-size: 20px;
    transition: 0.3s;
  }
  .cog-table i:hover {
    /* color: #4d4d4d; */
    color: #6d7986;
  }
  .block-check-field {
    display: flex;
    margin-bottom: 9px;
  }
  .block-check-field .custom-check {
    padding: 0;
  }
  .font-class {
    font-family: 'Montserrat', sans-serif;
  }
  .sync-btn {
    padding: 0 !important;
    width: 37px;
    min-width: 1px !important;
  }
  .sync-btn i {
    margin: 0;
  }
  .block-search {
    position: relative;
    width: 100%;
  }
  .popup-filter {
    position: absolute;
    background: #fff;
    width: 100%;
    margin-top: 7px;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    z-index: 999999;
    padding: 30px 25px 25px;
    box-shadow: 0px 5px 10px rgba(204, 197, 185, 0.5);
  }
  .filter-block p {
    color: #6d7986;
    margin-bottom: 7px;
    font-size: 14px;
  }
  .filter-status {
    margin-bottom: 15px;
  }
  .block-tab-btn {
    display: flex;
    justify-content: end;
  }
  .btn-search i {
    font-size: 19px;
    margin: 0;
  }
  .filter-close {
    top: 7px;
    right: 7px;
    padding: 15px !important;
    height: 15px !important;
  }
  .tab-status {
    padding: 4px 10px; 
    border-radius: 20px; 
    color: #fff;
  }
  .input-filters {
    position: absolute;
    font-size: 11px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    height: 100%;
    margin-left: 3px;
  }

</style>
